module.exports = __webpack_public_path__ + "static/media/mc_front_empty.20a4690f.svg";